<template>
  <div class="onboarding_page">
    <h2>Har ni en lista på medlemmar redan?</h2>
    <p>Ni har möjlighet att importera en lista från Excel med medlemmar.</p>
    <p>Innan ni gör detta bör ni skapa alla underföreningar som innehar medlemmar.</p>
    <p></p>
    <p></p>
    <p>
      <a href="/ml-import" target="_blank">Till Import >></a>
    </p>
    <div class="wizard_actions">
      <button
        class="btn_prev"
        @click="prev_page"
      >
        Föregående
      </button>
      <button
        class="btn_next"
        @click="next_page"
      >
        Nästa
      </button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'onboarding_page6_2',
  props: ['onboarding_data'],
  methods: {
    next_page() {
      this.$emit('update_data', { subcompanies_info: true })
      this.$emit('next_page')
    },
    prev_page() {
      this.$emit('update_data', { subcompanies_info: true })
      this.$emit('prev_page')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/components/forms/_memlist_wizard.scss";

</style>
